<template>
    <div class="Page">
        <Header Act="3"></Header>
        <div class="MaxWid">
            <div class="QueryBtn MarTop">
                <div class="QueryBtnItem" :class="{Act:i ==1}" @click="ToggleNav(1)">专业人员注册</div>
                <div class="QueryBtnItem" :class="{Act:i ==2}" @click="ToggleNav(2)">专业机构注册</div>
            </div>
            <div class="Steps">
                <div class="StepsItem" :class="{Act:stepId ==1,ColorBlank:ThisPage>1}">1. 基本信息</div>
                <div class="StepsItem" :class="{Act:stepId ==2,ColorBlank:ThisPage>2}">2. 专业信息</div>
                <div class="StepsItem" :class="{Act:stepId ==3,ColorBlank:ThisPage>3}" v-if="i !=2">3. 案例报告</div>
                <div class="StepsItem" :class="{Act:stepId ==4,ColorBlank:ThisPage>4}" v-if="i !=2">4. 推荐信息</div>
            </div>
            <BasicInfo v-if="stepId==1" :Type="i" @PageBtn="ToggleStep" :PageDisabled="PageDisabled"></BasicInfo>
            <SpecialtyInfo v-if="stepId==2" :TypeId="i" :id="CommId" @PageBtn="ToggleStep" :PageDisabled="PageDisabled"></SpecialtyInfo>
            <ReplenishInfo v-if="stepId==3 && i !=2" :TypeId="i" :id="CommId" @PageBtn="ToggleStep" :PageDisabled="PageDisabled"></ReplenishInfo>
            <Case v-if="stepId==4 &&i !=2" :TypeId="i" :id="CommId" @PageBtn="ToggleStep" :PageDisabled="PageDisabled" :user_group_id="user_group_id"></Case>
        </div>
        <Footer></Footer>
        <el-dialog :visible.sync="Agreement" width="50%" center :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div v-html="AgreementData" class="MaxHei"></div>
            <div class="AgreementBtn MarTop">
                <el-button type="primary" @click="Agreement = false">我知道了</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    import Banner from '@/components/banner/Banner';
    import BasicInfo from '@/components/applyReg/BasicInfo';
    import ReplenishInfo from '@/components/applyReg/ReplenishInfo';
    import SpecialtyInfo from '@/components/applyReg/SpecialtyInfo';
    import Case from '@/components/applyReg/Case';
    export default {
        components: {Header,Footer,Banner,BasicInfo,Case,ReplenishInfo,SpecialtyInfo},
        data() {
            return {
                i:1,
                stepId:1,
                ThisPage:1,
                CommId:"",
                PageData:"",
                Agreement:false,
                AgreementData:"",
                PageDisabled:false,
                user_group_id: "",
                isEditMode:false,           // 是否为编辑模式
                beforeUnloadHandler:null,   // 刷新/关闭清理事件句柄
            }
        },
        created() {
            if(this.$route.query.id){this.i = this.$route.query.id}
            if(this.$route.query.type){
                this.i = this.$route.query.type;
                this.isEditMode = true;
                // 编辑模式进入时，先清理本地缓存，确保加载最新数据
                this.clearApplyRegCache();
            }
        },
        mounted() {
            if(this.isEditMode){
                // 检查 InfoData 是否存在
                const infoData = localStorage.getItem("InfoData");
                if (!infoData) {
                    this.$message.error('数据获取失败，请返回重试');
                    this.$router.push('/UserInfo');
                    return;
                }
                try {
                    const parsedData = JSON.parse(infoData);
                    if (!parsedData || !parsedData.id) {
                        this.$message.error('数据不完整，请返回重试');
                        this.$router.push('/UserInfo');
                        return;
                    }
                    console.log('ApplyReg mounted, InfoData:', parsedData);
                } catch (e) {
                    console.error('解析 InfoData 失败:', e);
                    this.$message.error('数据格式错误，请返回重试');
                    this.$router.push('/UserInfo');
                    return;
                }
            }
            // 注册刷新/关闭浏览器时的清理
            this.beforeUnloadHandler = () => {
                this.clearApplyRegCache();
            };
            window.addEventListener('beforeunload', this.beforeUnloadHandler);
            this.GetAgreement();
        },
        beforeDestroy() {
            if(this.beforeUnloadHandler){
                window.removeEventListener('beforeunload', this.beforeUnloadHandler);
            }
        },
        beforeRouteLeave(to, from, next) {
            // 离开报名页面时清理本地缓存
            this.clearApplyRegCache();
            next();
        },
        methods: {
            // 清理报名流程中本地保存的数据
            clearApplyRegCache(){
                ['basicInfoData','specialtyInfoData','replenishInfoData','filteredUrl'].forEach(key=>{
                    localStorage.removeItem(key);
                });
            },
            GetAgreement(){
                this.$get("api/common/configInfo")
                .then(res => {
                     if(res.data.code == 1){
                        this.AgreementData = res.data.data.register_agreement;
                        this.Agreement = true;
                     }
                })
            },
            ToggleStep(s,id){
                console.log('ToggleStep called with:', s, id); // 检查是否被调用
                if(s=='next'){
                    if(this.stepId == 1){this.CommId = id;}
                    if(this.stepId == 2){this.user_group_id = id;}

                    this.stepId = this.stepId + 1;
                    this.ThisPage = this.stepId;
                }else{
                    this.stepId = this.stepId - 1;
                    this.ThisPage = this.stepId;
                }
            },
            ToggleNav(i){
                
                this.i = i;
                // if(this.stepId==4){
                    this.stepId =1;
                    this.ThisPage =1;
                // }
            },
            TogglePage(i){
                this.stepId = i;
                if(i!=this.ThisPage){
                    this.PageDisabled = true;
                }else{
                    this.PageDisabled = false;
                }
            },
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
        },
    }
</script>
<style>
    .el-select-dropdown__item{
        text-align: center;
    }
</style>
<style scoped>
    .Page {
        background: #fff;
    }
    .MaxHei{
        max-height: 500px;
        overflow: auto;
    }
    .BgColorBlue {
        background-color: #037dbe;
    }

    .BgColorYellow {
        background-color: #ed8404;
    }

    .BgColorGreen {
        background-color: #82ae1d;
    }
    .MarTop {
        margin-top: 20px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .QueryBtn{
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .QueryBtnItem{
        flex: 1;
        padding: 10px 0;
        text-align: center;
        border-bottom: 1px solid #ccc;
        font-weight: 400;
        font-size: 20px;
        color: #666666;
        cursor: pointer;
    }
    .QueryBtnItem:hover,
    .QueryBtnItem.Act{
        background: #0385EB;
        color: #fff;
    }
    .Steps{
        display: flex;
        align-items: center;
        margin: 30px 0;
    }
    .StepsItem{
        flex: 1;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #F5F5F5;
        position: relative;
        font-weight: 400;
        font-size: 18px;
        color: #999;
        cursor: default;
    }
    .StepsItem.ColorBlank{
        color: #000;
    }
    .StepsItem::after{
        content: "";
        border-top: 25px solid #fff;
        border-bottom: 25px solid #fff;
        border-left: 20px solid #F5F5F5;
        position: absolute;
        right: 0;
        top: 0;
    }
    .StepsItem::before{
        content: "";
        border-top: 25px solid transparent;
        border-bottom: 25px solid transparent;
        border-left: 20px solid #fff;
        position: absolute;
        left: 0;
        top: 0;
    }
    .StepsItem.Act{
        background: #0385EB;
        color: #fff;
    }
    .StepsItem.Act::after{
        border-left: 20px solid #0385EB;
    }
    .AgreementBtn{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    @media only screen and (max-width: 550px) {
       .Steps{
           display: none;
       }
       .QueryBtnItem{
           font-size: 18px;
       }
    }
</style>